import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Role } from '../types';

interface RoleState {
  selectedRole: Role | null;
  filters: {
    active: boolean | null;
    searchTerm: string;
  };
}

const initialState: RoleState = {
  selectedRole: null,
  filters: {
    active: null,
    searchTerm: '',
  },
};

const roleSlice = createSlice({
  name: 'role',
  initialState,
  reducers: {
    setSelectedRole: (state, action: PayloadAction<Role | null>) => {
      state.selectedRole = action.payload;
    },
    setActiveFilter: (state, action: PayloadAction<boolean | null>) => {
      state.filters.active = action.payload;
    },
    setSearchTerm: (state, action: PayloadAction<string>) => {
      state.filters.searchTerm = action.payload;
    },
    clearFilters: (state) => {
      state.filters = initialState.filters;
    },
  },
});

export const { setSelectedRole, setActiveFilter, setSearchTerm, clearFilters } =
  roleSlice.actions;

export default roleSlice.reducer;
